export default __webpack_public_path__ + "static/P_SearchThumb_IN-2908_Downloads-bbb3b7bd0c7a9837e139bd812908d49b.webp";